import { createReducer, on, createFeatureSelector, createSelector } from '@ngrx/store';
import { setConsultantData, setRaas, setPermissions, setOffice, setProjects } from '../actions/consultant.actions';
import { Consultant } from '../models/consultant.model';

export const initialState: Consultant = null;

const reducer = createReducer(initialState,
  on(setConsultantData, (state, consultant) => consultant),
  on(setRaas, (state, { token, client, googleDirectory, raas, profilePicture }) => ({
    ...state, token, client, googleDirectory, raas, profilePicture
  })),
  on(setPermissions, (state, { permissions }) => ({ ...state, permissions })),
  on(setOffice, (state, office) => ({ ...state, office })),
  on(setProjects, (state, { projects }) => ({ ...state, projects })),
);

export const fromConsultant = {
  selectConsultantState: createFeatureSelector<Consultant>('consultant'),
};

export function consultantReducer(state, action) {
  return reducer(state, action);
}
